import React from "react";
import { Trees, Axe, Shovel } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const services = [{
  title: "Forestry Mulching",
  description: "Utilizing our heavy-duty Kubota SVL973 with a professional mulcher, we grind trees and vegetation into nutrient-rich mulch. This eco-friendly method preserves topsoil, prevents erosion, and leaves your land ready for immediate use.",
  icon: Trees
}, {
  title: "Brush Removal",
  description: "Reclaim your property from invasive overgrowth. We strip away dense underbrush, briars, and saplings to restore visibility and usability to your pastures, fence lines, and wooded areas.",
  icon: Axe
}, {
  title: "Light Excavation",
  description: "Beyond clearing, we offer precision earthmoving services. From grading and drainage solutions to driveway prep and site leveling, we handle the essential dirt work to get your project started right.",
  icon: Shovel
}];
export default function LandClearingExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="land-clearing-expertise" ref={ref} className={cn("dark bg-background text-foreground py-20 relative overflow-hidden", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10", "transition-all duration-700 ease-out")}>
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] mix-blend-overlay"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold tracking-tight mb-4 text-foreground">
            Land Clearing Expertise
          </h2>
          <p className="text-muted-foreground text-lg">
            Professional grade equipment and experienced operators dedicated to transforming East Texas properties.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => <div key={i} data-index={i} className="h-full">
              <Card className="group h-full relative overflow-hidden border-border bg-card transition-all duration-300 hover:scale-[1.02] hover:border-primary hover:shadow-lg hover:shadow-primary/10">
                {}
                <div className="absolute inset-0 opacity-10 pointer-events-none bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear_gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
                
                <CardContent className="p-8 flex flex-col items-start relative z-10 h-full">
                  <div className="mb-6 p-3 rounded-lg bg-primary/10 border border-primary/20 group-hover:bg-primary/20 transition-colors duration-300">
                    <service.icon className="size-12 text-primary stroke-[1.5]" aria-hidden="true" />
                  </div>
                  
                  <h3 className="text-2xl font-bold mb-4 text-foreground group-hover:text-primary transition-colors duration-300">
                    {service.title}
                  </h3>
                  
                  <p className="text-muted-foreground leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}